<template>
    <transition name="fade">
        <st-modal-styled v-if="value" :width="width">
            <div class="st-modal-bg" data-target="close" @click="closeAreaHanlder" />
            <div class="st-modal">
                <slot name="header-hole">
                    <div class="st-modal-header">
                        <div class="st-modal-header__title">
                            <slot v-if="!title" name="header" />
                            {{ title }}
                        </div>
                        <awesome-icon v-show="closeVisible" name="times" @click="closeAreaHanlder" />
                    </div>
                </slot>
                <slot name="body-hole">
                    <div class="st-modal-body">
                        <slot name="body" />
                    </div>
                </slot>
                <slot name="footer-hole">
                    <div class="st-modal-footer">
                        <slot name="footer" />
                    </div>
                </slot>
            </div>
        </st-modal-styled>
    </transition>
</template>
<script>
import styled, { css } from "vue-styled-components";

const props = {
    width: Number
};

const StModalStyled = styled("div", props)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;

    .st-modal-bg {
        position: absolute;
        z-index: 11;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .st-modal {
        position: relative;
        display: inline-block;
        z-index: 12;
        background-color: #ffffff;
        font-size: 1.5rem;
        top: 10vh;
        left: 50%;
        transform: translateX(-50%);
        min-width: 30rem;
        padding: 2.4rem;
        border-radius: 5px;
        overflow: hidden;

        ${props =>
            props.width &&
            css`
                width: ${props.width}rem;
            `}

        &-header {
            font-size: 2rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: space-between;
            word-break: break-all;

            .awesome-icon {
                cursor: pointer;
                min-width: 40px;
                display: block;
                text-align: right;
            }
        }

        &-body {
            padding: 1.6rem 0;
            line-height: 1.6;
            word-break: break-all;
        }

        &-footer {
        }
    }
`;

export default {
    name: "StModal",
    data: () => ({
        closeEvent: null
    }),
    props: {
        ...props,
        title: String,
        value: {
            type: Boolean,
            default: () => true
        },
        // X 표 닫힘 버튼 클릭 visible 여부
        closeVisible: {
            type: Boolean,
            default: () => true
        },
        // esc keyup 시 modal 닫힘 여부
        escKeyAble: {
            type: Boolean,
            default: () => true
        },
        // background click 시 modal 닫힘 여부
        bgCloseAble: {
            type: Boolean,
            default: () => true
        }
    },
    methods: {
        closeEventHandler(ev) {
            const isEsc = ev.code === "Escape" || ev.key === "Escape" || ev.keyCode === 27;
            if (this.value === true && isEsc) {
                this.closeHandler();
            }
        },

        closeAreaHanlder(ev) {
            if (!this.bgCloseAble) return;

            if (this.value) {
                this.$emit("before-close");
                this.closeHandler();
            }
        },

        closeHandler() {
            this.$emit("input", false);
        }
    },
    mounted() {
        if (this.closeEvent === null) {
            this.closeEvent = window.addEventListener("keyup", this.closeEventHandler);
        }
    },
    beforeDestroy() {
        if (this.closeEvent !== null) {
            this.closeEvent = null;
            window.removeEventListener("keyup", this.closeEventHandler);
        }
    },
    components: {
        StModalStyled
    }
};
</script>
